export default __webpack_public_path__ + "static/media/share_realization_user_icon.ef6656fa.svg";